import axios  from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const getAllBlogsData = async()=>{
    try {
        const response = await apiService.get('/get-blogs')
        return response.data
    } catch (error) {
        
    }
}
export const getBlogsCategoryData = async()=>{
    try {
        const response = await apiService.get('/blog-categories-dropdown')
        return response.data
    } catch (error) {
        
    }
}
export const getBlogsTagsData = async()=>{
    try {
        const response = await apiService.get('/blog-tags-dropdown')
        return response.data
    } catch (error) {
        
    }
}
export const getBlogsRecentBlogsData = async()=>{
    try {
        const response = await apiService.get('/recent-blogs')
        return response.data
    } catch (error) {
        
    }
}

export const blogsCategoryFilter = async(categoryId)=>{
    try {
        const response = await apiService.get(`/get-category-blogs/${categoryId}`)
        return response.data
    } catch (error) {
        
    }
}
export const blogsTagsFilter = async(TagsId)=>{
    try {
        const response = await apiService.get(`/get-tag-blogs/${TagsId}`)
        return response.data
    } catch (error) {
        
    }
}
export const getSingleBlogsData = async(blogsID)=>{
    try {
        const response = await apiService.get(`/get-single-blog/${blogsID}`)
        return response.data
    } catch (error) {
        
    }
}